import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
`;

export const GreenLineWrapper = styled.div`
  position: absolute;
  width: 80px; // the same as StepWrapper first column width
  top: 20px; // the same as StepWrapper padding top
  bottom: 60px;
  display: flex;
  justify-content: center;
`;

export const GreenLine = styled.div`
  width: 1px;
  height: 100%;
  background: #1fde8b;
`;

export const StepWrapper = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  width: 370px;
  background-color: #2a2a2c;
  border-radius: 8px;
  padding: 20px 20px 20px 0px;
  outline: 1px solid #3e3e3e;
`;

export const Step = styled.div`
  font-size: 20px;
  line-height: 38px;
  font-weight: 700;
  color: #ffffff;
  width: 40px;
  height: 40px;
  outline: 1px solid #1fde8b;
  background: #2c3635;
  box-shadow: 0 6px 12px -7px rgba(0, 0, 0);
  border-radius: 50%;
  text-align: center;
  justify-self: center;
  z-index: 1;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TitleStep = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #fff;
`;

export const FormElement = styled.form``;

export const Error = styled.div`
  color: #fff;
  font-size: 14px;
  line-height: 20px;
`;
